module.exports = __webpack_public_path__ + "static/media/Minus-blue.724469a2.svg";